<div class="modal fade" id="kt_modal_purchase_manager_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Purchase Manager' : 'Add Purchase Manager' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="purchaseManagerForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Vehicle Search -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Vehicle</label>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control form-control-solid"
                  [(ngModel)]="vehicleSearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onVehicleSearchInput($event)"
                  (focus)="onVehicleInputFocus()"
                  (blur)="onVehicleInputBlur()"
                  placeholder="Search vehicles..."
                  autocomplete="off"
                  [disabled]="isEditMode || isVehiclePreSelected"
                />

                <!-- Loading indicator -->
                <div *ngIf="isVehicleSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                  <span class="spinner-border spinner-border-sm text-primary"></span>
                </div>

                <!-- Dropdown -->
                <div *ngIf="showVehicleDropdown" class="dropdown-menu show w-100 mt-1" style="max-height: 300px; overflow-y: auto;">
                  <div *ngIf="vehicleSearchResults.length === 0 && !isVehicleSearching" class="dropdown-item-text text-muted">
                    No vehicles found
                  </div>
                  <div *ngFor="let vehicle of vehicleSearchResults"
                       class="dropdown-item cursor-pointer d-flex align-items-center py-3"
                       (click)="selectVehicle(vehicle)">
                    <!-- Vehicle Image -->
                    <div class="symbol symbol-40px me-3">
                      <img [src]="getVehicleImageUrl(vehicle)"
                           [alt]="vehicle.name || 'Vehicle'"
                           class="symbol-label"
                           style="object-fit: cover;">
                    </div>
                    <!-- Vehicle Details -->
                    <div class="flex-grow-1">
                      <div class="fw-bold text-dark">{{ getVehicleDisplayName(vehicle) }}</div>
                      <div class="text-muted fs-7" *ngIf="vehicle.chassis_no">
                        Chassis: {{ vehicle.chassis_no }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="vehicle_id?.invalid && vehicle_id?.touched" class="text-danger fs-7 mt-1">
                Vehicle is required
              </div>
            </div>

            <!-- Amount -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Amount (JPY)</label>
              <input
                type="number"
                class="form-control form-control-solid"
                formControlName="amount"
                placeholder="Enter amount in JPY"
                min="0"
                step="1"
              />
              <div *ngIf="amount?.invalid && amount?.touched" class="text-danger fs-7 mt-1">
                <span *ngIf="amount?.errors?.['required']">Amount is required</span>
                <span *ngIf="amount?.errors?.['min']">Amount must be greater than or equal to 0</span>
              </div>
            </div>

            <!-- Purchase Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Purchase Date</label>
              <input
                type="date"
                class="form-control form-control-solid"
                formControlName="purchase_date"
              />
              <div *ngIf="purchase_date?.invalid && purchase_date?.touched" class="text-danger fs-7 mt-1">
                Purchase date is required
              </div>
            </div>

            <!-- Location -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Location</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="location"
                placeholder="Enter location"
              />
              <div *ngIf="location?.invalid && location?.touched" class="text-danger fs-7 mt-1">
                Location is required
              </div>
            </div>

            <!-- Vendor Search -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Vendor Name</label>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control form-control-solid"
                  [(ngModel)]="vendorSearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onVendorSearchInput($event)"
                  (focus)="onVendorInputFocus()"
                  (blur)="onVendorInputBlur()"
                  placeholder="Search vendors..."
                  autocomplete="off"
                />

                <!-- Loading indicator -->
                <div *ngIf="isVendorSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                  <span class="spinner-border spinner-border-sm text-primary"></span>
                </div>

                <!-- Dropdown -->
                <div *ngIf="showVendorDropdown" class="dropdown-menu show w-100 mt-1" style="max-height: 300px; overflow-y: auto;">
                  <div *ngIf="vendorSearchResults.length === 0 && !isVendorSearching" class="dropdown-item-text text-muted">
                    No vendors found
                  </div>
                  <div *ngFor="let vendor of vendorSearchResults"
                       class="dropdown-item cursor-pointer d-flex align-items-center py-3"
                       (click)="selectVendor(vendor)">
                    <!-- Vendor Details -->
                    <div class="flex-grow-1">
                      <div class="fw-bold text-dark">{{ getVendorDisplayName(vendor) }}</div>
                      <div class="text-muted fs-7" *ngIf="vendor.email">
                        {{ vendor.email }}
                      </div>
                      <div class="text-muted fs-8" *ngIf="vendor.phone">
                        {{ vendor.phone }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="vendor_id?.invalid && vendor_id?.touched" class="text-danger fs-7 mt-1">
                Vendor is required
              </div>
            </div>

            <!-- Admin Comment -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Admin Comment</label>
              <textarea
                class="form-control form-control-solid"
                formControlName="admin_comment"
                rows="3"
                placeholder="Enter admin comment"
              ></textarea>
            </div>

            <!-- Invoice File Upload -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Invoice File</label>
              <div class="d-flex align-items-center">
                <input
                  type="file"
                  class="form-control form-control-solid me-3"
                  id="invoice_file"
                  (change)="onFileSelected($event)"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  [disabled]="isFileUploading"
                />

                <!-- Upload Progress -->
                <div *ngIf="isFileUploading" class="d-flex align-items-center me-3">
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  <span class="text-muted">Uploading...</span>
                </div>

                <!-- File Actions -->
                <div *ngIf="uploadedFileUrl && !isFileUploading" class="d-flex align-items-center">
                  <button
                    type="button"
                    class="btn btn-sm btn-light-primary me-2"
                    (click)="openFile()"
                    title="View File"
                  >
                    <i class="ki-duotone ki-eye fs-4">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                    </i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-light-danger"
                    (click)="removeFile()"
                    title="Remove File"
                  >
                    <i class="ki-duotone ki-trash fs-4">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                      <span class="path4"></span>
                      <span class="path5"></span>
                    </i>
                  </button>
                </div>
              </div>
              <div class="form-text">Allowed file types: pdf, doc, docx, jpg, jpeg, png</div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
          <button
            type="submit"
            class="btn btn-primary indicator"
            style="min-width: 180px;"
            [disabled]="isLoading || isFileUploading"
          >
            <span class="indicator-label" *ngIf="!isLoading">{{ isEditMode ? 'Update' : 'Add' }} Purchase Manager</span>
            <span class="indicator-progress" *ngIf="isLoading">
              Please wait...
              <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
